
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import LanguageDropdown from "../modals/LanguageDropdown.vue";
import ButtonLanguage from "./ButtonLanguage.vue";
import ButtonLogin from "./ButtonLogin.vue";
import SearchHeader from "./SearchHeader.vue";
import { EventType, trackEvent } from "@/helpers/AmplitudeHelper";

export default defineComponent({
  name: "HeaderSecondary",
  props: {
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SearchHeader,
    ButtonLanguage,
    LanguageDropdown,
    ButtonLogin,
  },
  methods: {
    ...mapActions(["toggleAuthModal", "toggleLanguageDropdown", "setPage", "getNewTenders", "resetFilters", "setQuery"]),
    goBack() {
      this.$router.go(-1);
    },
    handleLogoClick() {
      if (this.$route.name === 'tenderSerp') {
      this.resetFilters();
      this.setQuery({ query: '' });
      this.$router.replace('/');
    }
    },
    trackHeaderFavourites() {
      trackEvent(EventType.header_favorites)
    },
    trackHeaderTemplates() {
      trackEvent(EventType.header_templates)
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "showAuthModal", "showLanguageDropdown"]),
    currentRoute () {
      return this.$route.name
    }
  },
});
